import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=72ee0915&scoped=true&"
import script from "./Preference.vue?vue&type=script&lang=js&"
export * from "./Preference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ee0915",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ee0915')) {
      api.createRecord('72ee0915', component.options)
    } else {
      api.reload('72ee0915', component.options)
    }
    module.hot.accept("./Preference.vue?vue&type=template&id=72ee0915&scoped=true&", function () {
      api.rerender('72ee0915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Preference.vue"
export default component.exports